<script lang="ts">
  /**
   * Four bars, like a phone's signal meter, for how well one viewer's
   * connection keeps up. 0 draws the bars empty (not connected yet).
   */
  let { level, label = '' }: { level: 0 | 1 | 2 | 3 | 4; label?: string } = $props()
</script>

<span
  class="signal signal--{level <= 1 ? 'poor' : level === 2 ? 'weak' : 'good'}"
  role="img"
  aria-label={label}
  title={label}
>
  {#each [1, 2, 3, 4] as bar (bar)}
    <i class:signal__on={bar <= level} style="height: {30 + bar * 17}%"></i>
  {/each}
</span>
